export default __webpack_public_path__ + "static/messages-onboarding-b4e89a9fbe2e0aca79d0b00f9cf6a1818823c40db43220bf0cb7fef251ba5c1f.jpg";